<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <fire-register-header ref="fireRegisterHeader" :title="title" :path="path" :text1="text1"
        :locationOptions="locationIdOptions" @location-changed="onLocationChange" />
      <!-- /Page Header -->

      <div class="row">

        <div class="col-md-12">
          <div v-if="!loader">
            <div class="table-responsive">

              <a-table class="stripped table-hover" size="small" :columns="columns" :data-source="usersData"
                :pagination="false" v-if="usersData.length">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'image_path'">
                    <h2 class="table-avatar">
                      <a href="javascript:;" class="avatar" @click="openImagePreview(record)">
                        <img :src="getImage(record.image_path)" alt="User Image" v-if="record.image_path" />
                        <img src="../../../assets/img/avatar/avatar-29.png" alt="User Image" v-else />
                      </a>
                    </h2>
                  </template>
                  <template v-else-if="column.key === 'name'">
                    <h5 class="table-avatar">
                      <div v-if="record.user_id">
                        <action-dropdown @banked-time="bankedTimeClicked" :employee="{ ...record.user, name: `${record.user.first_name} ${record.user.last_name}`, id: record.user_id, account_type: record.user.account_type }" variant="text" :reportAsEvent="true" @edit="editClicked" @leaves="leavesClicked"
                          @attendance="attendanceClicked" @sick-leave="sickLeaveClicked" @add-face-template="addFaceTemplateClicked" @face-templates="faceTemplatesClicked" @toggle-monitoring="monitorClicked" @report="viewReport"
                          @reset-password="resetPasswordClicked" @assign-employee="assignEmployeeClicked" />
                      </div>
                      <div v-else>
                        {{
                          record[getDynamicKey(record)]
                            ? `${record[getDynamicKey(record)].first_name} ${record[getDynamicKey(record)].last_name}`
                            : '--'
                        }}
                      </div>
                    </h5>
                  </template>
                  <template v-else-if="column.key === 'User'">
                    <div v-if="getDynamicKey(record) === 'Unrecognized'">
                      <span class="text-danger">{{ getDynamicKey(record) }}</span>
                    </div>
                    <div v-else>
                      {{ getDynamicKey(record) === "user" ? 'Employee' : capitalizeFirstLetter(getDynamicKey(record)) }}
                    </div>

                  </template>
                  <template v-else-if="column.key === 'location'">
                    {{ getLocationName(record.location_id) }}
                  </template>
                  <template v-else-if="column.key === 'accepted_banked_time'">



                    {{ record.accepted_banked_time ? record.accepted_banked_time : 0 }}

                  </template>

                  <template v-else-if="column.key === 'action'">

                    <a
                            @click="checkOutClicked(record)"
                            ><i class="fa-solid fa-sign-out m-r-5"></i>Check Out</a
                          >
                  </template>
                </template>
              </a-table>
              <div v-else>
                <div class="card text-center">
                  <div class="card-body">
                    <img src="../../../assets/img/avatar/no-data.png" alt="no-data" srcset="" class="responsive-img">
                    <p>No Employee.</p>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div class="d-flex justify-content-center text-center mt-5" v-else>
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->

    <!-- Image Preview Modal -->
    <div class="modal fade" id="image_preview_modal" tabindex="-1" aria-labelledby="imagePreviewLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="imagePreviewLabel">{{ selectedEmployeeName }}</h5>
            <button type="button" class="btn-close close-btn" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <img :src="selectedImageUrl" alt="Employee Image" class="img-fluid preview-image" />
          </div>
        </div>
      </div>
    </div>
    <leaves-admin-modal ref="leaveAdmin" @allLeaves="getActivity"></leaves-admin-modal>
    <sick-leave-details-modal ref="sickLeaveDetails"></sick-leave-details-modal>
    <sick-leave-modal ref="sickLeave"></sick-leave-modal>
    <edit-employee-modal ref="editEmployee" @editedUser="getEmployees"></edit-employee-modal>
    <add-face-template-modal ref="addface"></add-face-template-modal>
    <face-templates-modal ref="faceTemplates"></face-templates-modal>
    <employee-report-modal ref="employeeReportModal"></employee-report-modal>
    <reset-password-modal ref="resetPasswordModal"></reset-password-modal>
    <assign-employee-modal ref="assignEmployeeModal" @updated="getActivity"></assign-employee-modal>
  </div>
  <!-- /Page Wrapper -->
    <view-banked-time-details-modal ref="viewBankedTimeDetails"></view-banked-time-details-modal>
</template>

<script>
import axios from 'axios';
import dayjs from 'dayjs';
import { Modal } from 'bootstrap';
import { VUE_APP_API_BASE_URL } from "../../../config";
import { getImage } from "@/utils/util-funcitons";
import ActionDropdown from "@/components/action-dropdown.vue";
import FaceTemplatesModal from "@/components/modal/face-templates-modal.vue";
import AssignEmployeeModal from "@/components/modal/assign-employee-modal.vue";




const columns = [
  {
    title: "Image",
    dataIndex: "image_path",
    key: "image_path"
  },
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: {
      compare: (a, b) => {
        a = a.name.toLowerCase();
        b = b.name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Date Time",
    dataIndex: "created_at",
    key: "created_at",
    // sorter: true,
  },
  {
    title: "Type",
    dataIndex: "type",
    key: "type",
    // sorter: true,
  },
  {
    title: "User",
    dataIndex: "User",
    key: "User",
    // sorter: true,
  },
  {
    title: "location",
    dataIndex: "location",
    key: "location",
    // sorter: true,
  },
  {
    title: "Action",
    sorter: true,
    key: "action",
  },
];


import { monitorMixin } from "@/mixins/monitorMixin";
export default {
  mixins: [monitorMixin],
  components: {
    ActionDropdown,
    FaceTemplatesModal,
    AssignEmployeeModal
  },
  data() {
    const today = new Date();
    const endOfYear = new Date(today.getFullYear(), 11, 31);
    return {
      columns,
      activeContractor: null,
      title: "Fire Register",
      path: "Dashboard",
      text1: "Fire Register",
      usersData: [],
      locationIdOptions: [],
      employeeData: [],
      perPage: 50,
      current: 1,
      total: 0,
      employee_code: "",
      employee_name: "",
      company_role_id: "",
      companyId: [],
      loader: false,
      load: false,
      type: '',
      selectedUsersFromFilter: [],
      dateRange: {
        start_date: dayjs(today).format('YYYY-MM-DD'),
        end_date: dayjs(endOfYear).format('YYYY-MM-DD'),
      },
      DownloadLoad: false,
      usersPresent: [],
      selectedImageUrl: "",
      selectedEmployeeName: ""
    };
  },
  mounted() {
    this.getActivity(),
      this.getLocationIds(),
      this.getEmployees()
  },

  methods: {
    bankedTimeClicked(record) {
      if(this.$refs.viewBankedTimeDetails) {
        this.$refs.viewBankedTimeDetails.updateValues(record, {});
      }
    },


    getImage,
    async getLocationIds() {
      await axios.get(`${VUE_APP_API_BASE_URL}/location/all`)
        .then((response) => {
          if (response.data.status) {
            this.locationIdOptions = response.data.data
            this.locationIdOptions.forEach(element => {
              delete element['created_at'];
              delete element['updated_at'];
              delete element['latitude'];
              delete element['longitude'];
              element['text'] = element['name'];
              delete element['name'];
            }
            )
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        }).catch(function (error) {
          console.log(error);
        })
        .finally(() => {

        });
    },

    DownloadPdf() {
      this.$refs.fireRegisterHeader.updateStatus(this.usersData);
    },

    getLocationName(id) {
      const location = this.locationIdOptions.find(item => item.id === id);
      return location ? location.text : '-';
    },

    getEmployees() {


      axios.get(`${VUE_APP_API_BASE_URL}/user/user-list`)
        .then((response) => {
          if (response.data.status) {
            this.employeeData = response.data.data;

            this.employeeData.forEach(element => {
              element["text"] = element["first_name"] + " " + element["last_name"];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {

        });
    },

    getEmployeeName(id) {
      const name = this.employeeData.find(item => item.id === id);
      return name ? name.text : '-';
    },




    formatDate(dateString) {
      const date = new Date(dateString);

      // Then specify how you want your dates to be formatted
      return date.toISOString().replace('T', ' ').substring(0, 19);
    },

    addUserIdFace(item) {
      this.$refs.addUserIdToFace.updateValues(item, this.dateRange);
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },

    onLocationChange(locationId) {
      this.getActivity(locationId);
    },

    getActivity(locationId = '') {
      this.loader = true;
      axios.post(`${VUE_APP_API_BASE_URL}/activity/get-fire-register`, { location_id: locationId })
        .then((response) => {
          if (response.data.status) {
            console.log(response.data.data);
            this.usersData = response.data.data;
            this.usersData.forEach(element => {
              element["name"] = element["first_name"] + " " + element["last_name"];
            });
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          this.loader = false;
          this.DownloadPdf();
        });
    },

    sickLeaveClicked(record) {
      this.$refs.sickLeave.updateValues(record);
    },
    leavesClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/leaves-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },
    attendanceClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/attendance-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },
    addFaceTemplateClicked(record) {
      this.$refs.addface.updateValues(record);
    },
    faceTemplatesClicked(employee) {
      this.$refs.faceTemplates.showTemplates(employee);
    },
    editClicked(record) {
      this.$refs.editEmployee.updateValues(record);
    },

    async addUserToBankedTime(userId) {

      await axios.post(`${VUE_APP_API_BASE_URL}/banked-time/user/add`, { user_id: userId })
        .then((response) => {
          if (response.data.status) {
            this.$toast.success(response.data.message);
          } else {
            this.$toast.error(response.data.message || response.data.errors);
          }
        }).catch(function (error) {
          console.log(error);
        });
    },



    async checkOutClicked(record) {
      let user_id = ''
      let visitor_id = ''
      let contractor_id = ''
      if (record.user_id) {
        user_id = record.user_id;
      }else if (record.visitor_id){
        visitor_id = record.visitor_id;
      } else{
        contractor_id = record.contractor_id;
      } 

         await axios.post(`${VUE_APP_API_BASE_URL}/activity/check-out-fire-register`, { 
          type:'Check Out',
          user_id:user_id ?? null,
          visitor_id:visitor_id?? null,
          contractor_id:contractor_id?? null,
          latitude:record.latitude,
          longitude:record.longitude,
          location_id:record.location_id
        })
          .then((response) => {
            if (response.data.status) {
              this.$toast.success(response.data.message);
              this.getActivity()
            } else {
              this.$toast.error(response.data.message || response.data.errors);
            }
          }).catch(function (error) {
            console.log(error);
          });
    },

    getDynamicKey(userData) {
      if (userData.user_id) return "user"
      else if (userData.visitor_id) return "visitor"
      else if (userData.contractor_id) return "contractor"
      else return "Unrecognized"
    },

    openImagePreview(record) {
      const dynamicKey = this.getDynamicKey(record);
      if (record.image_path) {
        this.selectedImageUrl = this.getImage(record.image_path);
      } else {
        this.selectedImageUrl = require('../../../assets/img/avatar/avatar-29.png');
      }
      if (record[dynamicKey]) {
        this.selectedEmployeeName = `${record[dynamicKey].first_name} ${record[dynamicKey].last_name}`;
      } else {
        this.selectedEmployeeName = 'Unrecognized';
      }
      const modal = new Modal(document.getElementById('image_preview_modal'));
      modal.show();
    },

    viewReport(record) {
      this.$refs.employeeReportModal.updateValues(record.id, this.dateRange.start_date, this.dateRange.end_date);
      const modal = new Modal(document.getElementById('employee_report_modal'));
      modal.show();
    },
    resetPasswordClicked(record) {
      this.$refs.resetPasswordModal.updateValues(record);
    },
    assignEmployeeClicked(record) {
      this.$refs.assignEmployeeModal.updateValues(record);
    },

  }
};
</script>

<style scoped>
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-prev,
:where(.css-dev-only-do-not-override-1hsjdkk).ant-pagination .ant-pagination-next {
  background-color: #ffffff00 !important;
}

.inline-item {
  display: inline-block;
  margin-right: 2px;
  /* Adjust spacing between items */
}

.table-responsive {
  overflow-x: auto;
  overflow-y: visible;
}

.responsive-img {
  width: 100%;
  max-width: 100px;
  height: auto;
}

/* .custom-select {
  min-width: 30px;
} */

.custom-select select {
  appearance: none;
  width: 50px;
  font-size: 14px;
  padding: 2px 5px;
  background-color: #fff;
  border: 1px solid #caced1;
  border-radius: 0.25rem;
  color: #000;
  cursor: pointer;
}

.avatar {
  background-color: transparent;
  color: #FFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  height: 50px;
  line-height: 34px;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  vertical-align: middle;
  width: 50px;
  position: relative;
  white-space: nowrap;
  margin: 0 10px 0 0;
  border-radius: 50%;
  cursor: pointer;
}

.avatar:hover {
  opacity: 0.8;
}

.preview-image {
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
}

.close-btn {
  background-color: #A6A8A9;
  height: 20px;
  width: 20px;
  border: 1px solid #A6A8A9;
  font-size: 20px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.close-btn:hover {
  background-color: #099bf8;
  color: #ffffff;
  border-color: #099bf8;
}

.close-btn:hover span {
  color: #FFF;
}

.close-btn span {
  color: #373B3E;
}
</style>
